"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("quark-core/styles");

var _default = {
  container: {
    width: '100%',
    paddingTop: 4 * _styles.baseDim,
    paddingBottom: 4 * _styles.baseDim,
    paddingLeft: 5 * _styles.baseDim,
    paddingRight: 5 * _styles.baseDim,
    borderRadius: 2,
    marginBottom: 6,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  contentContainer: {
    marginRight: 8
  },
  iconContainer: {
    color: 'white',
    width: 24,
    height: 24
  },
  messageStyle: {
    color: 'white',
    fontSize: 16
  },
  closeIcon: {
    width: 24,
    height: 24,
    cursor: 'pointer',
    color: 'white'
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/alerts/BaseAlert/styles.js
// module id = ./node_modules/quark-web/components/alerts/BaseAlert/styles.js
// module chunks = 0